import { useState, useLayoutEffect, RefObject } from 'react';

const SCROLL_EDGE_THRESHOLD = 1;

function useBtnDisabledState(
  sliderWrapperRef: RefObject<HTMLElement>,
  active = true,
) {
  const [isAtLeft, setIsAtLeft] = useState(true);
  const [isAtRight, setIsAtRight] = useState(false);

  useLayoutEffect(() => {
    if (!active) {
      setIsAtLeft(true);
      setIsAtRight(false);
      return undefined;
    }

    const el = sliderWrapperRef.current;
    if (!el) {
      return undefined;
    }

    const syncDisabledState = (): void => {
      const { scrollLeft, scrollWidth, clientWidth } = el;
      setIsAtLeft(scrollLeft <= SCROLL_EDGE_THRESHOLD);
      setIsAtRight(
        scrollLeft + clientWidth >= scrollWidth - SCROLL_EDGE_THRESHOLD,
      );
    };

    syncDisabledState();
    el.addEventListener('scroll', syncDisabledState, { passive: true });

    const resizeObserver =
      typeof ResizeObserver !== 'undefined'
        ? new ResizeObserver(syncDisabledState)
        : null;
    resizeObserver?.observe(el);
    const segmentEl = el.querySelector('.tea-segment');
    if (segmentEl) {
      resizeObserver?.observe(segmentEl);
    }

    return () => {
      el.removeEventListener('scroll', syncDisabledState);
      resizeObserver?.disconnect();
    };
  }, [active, sliderWrapperRef]);

  return [isAtLeft, isAtRight] as const;
}

export default useBtnDisabledState;
